module.exports = __webpack_public_path__ + "img/momiji inubashiri_sc2.2d707946.png";